module.exports = __webpack_public_path__ + "static/media/cathrine.5f6e74b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profiles/cathrine.jpg
// module id = 930
// module chunks = 0